import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import StatusBadge from '../../components/common/StatusBadge';
import { Loader, ErrorBanner } from '../../components/common/Feedback';
import { getClientHistory } from '../../api/clients';
import { formatDate, formatCurrency } from '../../utils/format';

export default function ClientDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getClientHistory(id)
      .then((res) => setData(res.data))
      .catch((err) => setError(err.response?.data?.message || 'Failed to load client history.'));
  }, [id]);

  return (
    <DashboardLayout title="Client History">
      <div className="page-header">
        <div>
          <h1 className="heading">{data ? data.client.clientName : 'Client'}</h1>
          {data && <p className="page-subtext">{data.client.companyName} &middot; {data.client.email}</p>}
        </div>
        <Link to="/clients" className="btn-link">Back to Clients</Link>
      </div>

      <ErrorBanner message={error} />
      {!data && !error && <Loader text="Loading client history..." />}

      {data && (
        <>
          <div className="card">
            <h3 className="subheading">Projects ({data.projects.length})</h3>
            {data.projects.length === 0 && <p className="text-muted">No projects yet.</p>}
            {data.projects.map((p) => (
              <div key={p.id} className="flex-between" style={{ padding: '8px 0', borderBottom: '1px solid var(--color-border)' }}>
                <span>{p.projectName}</span>
                <StatusBadge status={p.status} />
              </div>
            ))}
          </div>

          <div className="card">
            <h3 className="subheading">Invoices ({data.invoices.length})</h3>
            {data.invoices.length === 0 && <p className="text-muted">No invoices yet.</p>}
            {data.invoices.map((inv) => (
              <div key={inv.id} className="flex-between" style={{ padding: '8px 0', borderBottom: '1px solid var(--color-border)' }}>
                <span>{inv.invoiceNumber} &middot; {formatCurrency(inv.totalAmount)}</span>
                <StatusBadge status={inv.status} />
              </div>
            ))}
          </div>

          <div className="card">
            <h3 className="subheading">Support Tickets ({data.tickets.length})</h3>
            {data.tickets.length === 0 && <p className="text-muted">No tickets yet.</p>}
            {data.tickets.map((t) => (
              <div key={t.id} className="flex-between" style={{ padding: '8px 0', borderBottom: '1px solid var(--color-border)' }}>
                <span>{t.subject}</span>
                <StatusBadge status={t.status} />
              </div>
            ))}
          </div>

          <div className="card">
            <h3 className="subheading">Recent Documents ({data.documents.length})</h3>
            {data.documents.length === 0 && <p className="text-muted">No documents yet.</p>}
            {data.documents.map((d) => (
              <div key={d.id} className="flex-between" style={{ padding: '8px 0', borderBottom: '1px solid var(--color-border)' }}>
                <span>{d.fileName} (v{d.version})</span>
                <span className="text-muted">{formatDate(d.createdAt)}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </DashboardLayout>
  );
}
